module.exports = __webpack_public_path__ + "31b34f8e27ea75a67c61bea0b6ee4db0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-s.png
// module id = 2237
// module chunks = 0